import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const login = localStorage.getItem("token")!
    ? localStorage.getItem("token")!
    : false;
  return login !== false ? <Outlet /> : <Navigate to={`/login`} replace />;
};

export default PrivateRoute;
